import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Autocomplete from '@mui/material/Autocomplete';

const todayISO = () => new Date().toISOString().slice(0,10);

/**
 * Props:
 * - products: [] (must include { iref, name, sku })
 * - selectedProduct: object|null
 * - dateValue: 'YYYY-MM-DD'
 * - onlyWithPrice: boolean
 * - onChange: ({ product?, date?, only_with_price? }) => void
 */
export default function ListsProductFilters({
  products = [],
  selectedProduct = null,
  dateValue = todayISO(),
  onlyWithPrice = true,
  onChange = () => {},
}){
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2,
        backgroundColor: "transparent",
      }}
    >
      <CardContent sx={{ p: 0, pt: 1.25, pb: 0.5 }}>
        {/* left-aligned, responsive row */}
        <Box sx={{ display:'flex', gap:2, alignItems:'center', flexWrap:'wrap', pt: 0.25 }}>
          {/* Product select */}
          <Box sx={{ width: '100%', maxWidth: 400, flex: '0 1 520px' }}>
            <Autocomplete
              size="small"
              value={selectedProduct}
              onChange={(_, value) => onChange({ product: value || null })}
              options={products}
              autoHighlight
              fullWidth
              getOptionLabel={(opt) => (opt?.name ? `${opt.name}${opt.sku ? ` · ${opt.sku}` : ''}` : '')}
              isOptionEqualToValue={(o, v) => o?.iref === v?.iref}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Product"
                  placeholder="Type name or SKU…"
                  InputLabelProps={{ sx: { color: '#e3e3e5' } }}
                  inputProps={{ ...params.inputProps, sx: { color: '#e3e3e5' } }}
                  sx={{
                    '& .MuiOutlinedInput-root': { color:'#e3e3e5' },
                    '& label': { color:'#e3e3e5' },
                    '& fieldset': { borderColor: 'rgba(227, 227, 229, 0.35)' },
                  }}
                />
              )}
            />
          </Box>

          {/* Date */}
          <TextField
            size="small"
            type="date"
            label="Date"
            value={dateValue || todayISO()}
            onChange={(e) => onChange({ date: e.target.value })}
            InputLabelProps={{ shrink: true, sx: { color: '#e3e3e5' } }}
            inputProps={{ sx: { color: '#e3e3e5' } }}
            sx={{
              minWidth: 170,
              '& fieldset': { borderColor: 'rgba(227, 227, 229, 0.35)' },
            }}
          />

          {/* Only with price */}
          <FormControlLabel
            sx={{ color:'#e3e3e5', ml: 0 }}
            control={
              <Checkbox
                checked={!!onlyWithPrice}
                onChange={(e) => onChange({ only_with_price: e.target.checked })}
                color="primary"
              />
            }
            label={<Typography variant="body2" sx={{ color:'#e3e3e5' }}>Only with price</Typography>}
          />
        </Box>
      </CardContent>
    </Card>
  );
}
